import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Starts every newly opened page at the top. The app uses BrowserRouter, so
 * React Router's <ScrollRestoration> is not available, and without this the
 * window keeps the previous page's offset (e.g. the training diary, scrolled
 * down to today, leaves the dashboard scrolled down too).
 *
 * Only a new path counts: back/forward (POP) is left to the browser and to the
 * pages that restore their own position (the feed), and a change of query
 * string or hash (tabs, filters, anchors) keeps the page where it is. A layout
 * effect, rendered before the routes, so it runs before paint and before any
 * page's own scrolling (the diary jumping to today).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only a path change should scroll
  }, [pathname]);

  return null;
}
